import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from './links';
import { LINKS } from '@/constants/links';
import { Button } from './buttons';
import { useRouter } from 'next/router';
import brain from '@/assets/images/brain-doesnt-know.png';
import heart from '@/assets/images/heart-panic.png';
interface Props {
  error?: string;
  variant?: 'basic' | 'extended';
  onRetry?: () => void;
}
export function ErrorSection(props) {
  const $ = _c(26);
  const {
    variant: t0
  } = props;
  const variant = t0 === undefined ? "extended" : t0;
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== props.error || $[2] !== t) {
    t2 = props.error ?? t("queryError.title");
    $[1] = props.error;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h3 className="mb-4 text-base font-semibold whitespace-normal md:text-2xl">{t2}</h3>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link to={LINKS().contact} testId="errorSectionReload" analyticsParam="errorSectionReload" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = <p><Trans t={t} i18nKey="queryError.text">{t4}</Trans></p>;
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props || $[10] !== router) {
    t6 = () => props.onRetry?.() || router.reload();
    $[9] = props;
    $[10] = router;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("queryError.button");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <Button testId="errorSectionTryAgain" analyticsParam="errorSectionTryAgain" onClick={t6} variant="primary" className="mt-12" align="center">{t7}</Button>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t3 || $[18] !== t5 || $[19] !== t8) {
    t9 = <div className="mx-auto flex max-w-[23rem] flex-col">{t3}{t5}{t8}</div>;
    $[17] = t3;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== variant) {
    t10 = variant === "extended" && <><div className="absolute top-10 left-5 hidden lg:block"><Image src={brain} alt="" width={300} /></div><div className="absolute -top-5 right-0 hidden lg:block"><Image src={heart} alt="" width={300} /></div></>;
    $[21] = variant;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <section className="relative z-10 mx-auto max-w-292 pb-12 text-center lg:pb-36">{t9}{t10}</section>;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}